function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  
  var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var detail = {
      detail: data
    };
    var event = new CustomEvent(eventName, data ? detail : null);
    document.dispatchEvent(event);
  };
  
  /**
   *  @class
   *  @function Quantity
   */
  if (!customElements.get('quantity-selector')) {
    class QuantityInput extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.qty');
        this.step = this.input.getAttribute('step');
        this.changeEvent = new Event('change', {
          bubbles: true
        });
        // Create buttons
        this.subtract = this.querySelector('.minus');
        this.add = this.querySelector('.plus');
  
        // Add functionality to buttons
        this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
        this.add.addEventListener('click', () => this.change_quantity(1 * this.step));
  
      }
      connectedCallback() {
        this.classList.add('buttons_added');
      }
      change_quantity(change) {
        // Get current value
        let quantity = Number(this.input.value);
  
        // Ensure quantity is a valid number
        if (isNaN(quantity)) quantity = 1;
  
        // Check for min & max
        if (this.input.getAttribute('min') > (quantity + change)) {
          return;
        }
        if (this.input.getAttribute('max')) {
          if (this.input.getAttribute('max') < (quantity + change)) {
            return;
          }
        }
        // Change quantity
        quantity += change;
  
        // Ensure quantity is always a number
        quantity = Math.max(quantity, 1);
  
        // Output number
        this.input.value = quantity;
  
        this.input.dispatchEvent(this.changeEvent);
      }
    }
    customElements.define('quantity-selector', QuantityInput);
  }
  
  /**
   *  @class
   *  @function ArrowSubMenu
   */
  class ArrowSubMenu {
  
    constructor(self) {
      this.submenu = self.parentNode.querySelector('.sub-menu');
      this.arrow = self;
      // Add functionality to buttons
      self.addEventListener('click', (e) => this.toggle_submenu(e));
    }
  
    toggle_submenu(e) {
      e.preventDefault();
      let submenu = this.submenu;
  
      if (!submenu.classList.contains('active')) {
        submenu.classList.add('active');
  
      } else {
        submenu.classList.remove('active');
        this.arrow.blur();
      }
    }
  }
  let arrows = document.querySelectorAll('.thb-arrow');
  arrows.forEach((arrow) => {
    new ArrowSubMenu(arrow);
  });
  
  /**
   *  @class
   *  @function ProductCard
   */
  if (!customElements.get('product-card')) {
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.swatches = this.querySelector('.product-card-swatches');
        this.image = this.querySelector('.product-featured-image-link .product-primary-image');
        this.secondary = this.querySelector('.product-featured-image-link .product-secondary-image');
        this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      }
      connectedCallback() {
        if (this.swatches) {
          this.enableSwatches();
        }
        if (this.quick_add) {
          this.enableQuickView();
        }
        if (this.secondary) {
          window.addEventListener('load', (event) => {
            lazySizes.loader.unveil(this.secondary);
          });
        }
      }
      enableSwatches() {
        let swatch_list = this.swatches.querySelectorAll('.product-card-swatch'),
          org_srcset = this.image ? this.image.dataset.srcset : '';
  
  
        swatch_list.forEach((swatch, index) => {
          window.addEventListener('load', (event) => {
            let image = new Image();
            image.srcset = swatch.dataset.srcset;
            lazySizes.loader.unveil(image);
          });
          swatch.addEventListener('mouseover', () => {
  
            [].forEach.call(swatch_list, function (el) {
              el.classList.remove('active');
            });
            if (this.image) {
              if (swatch.dataset.srcset) {
                this.image.setAttribute('srcset', swatch.dataset.srcset);
              } else {
                this.image.setAttribute('srcset', org_srcset);
              }
            }
  
            swatch.classList.add('active');
          });
          swatch.addEventListener('click', function (evt) {
            window.location.href = this.dataset.href;
            evt.preventDefault();
          });
        });
      }
      enableQuickView() {
        this.quick_add.addEventListener('click', this.quickAdd.bind(this));
      }
  
      quickAdd(evt) {
        evt.preventDefault();
        if (this.quick_add.disabled) {
          return;
        }
        this.quick_add.classList.add('loading');
        this.quick_add.setAttribute('aria-disabled', true);
  
        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          }
        };
  
        let formData = new FormData(this.form);
  
        formData.append('id', this.quick_add.dataset.productId);
        formData.append('quantity', 1);
        formData.append('sections', this.getSectionsToRender().map((section) => section.section));
        formData.append('sections_url', window.location.pathname);
  
        config.body = formData;
  
        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              return;
            }
            this.renderContents(response);
  
            dispatchCustomEvent('cart:item-added', {
              product: response.hasOwnProperty('items') ? response.items[0] : response
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.quick_add.classList.remove('loading');
            this.quick_add.removeAttribute('aria-disabled');
          });
  
        return false;
      }
      getSectionsToRender() {
        return [{
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form'
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }];
      }
      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section => {
          if (!document.getElementById(section.id)) {
            return;
          }
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          if (typeof CartDrawer !== 'undefined') {
            new CartDrawer();
          }
          if (typeof Cart !== 'undefined') {
            new Cart().renderContents(parsedState);
          }
        }));
  
  
        if (document.getElementById('Cart-Drawer')) {
          document.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
  
          dispatchCustomEvent('cart-drawer:open');
        }
  
      }
      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }
    }
    customElements.define('product-card', ProductCard);
  }
  
  /**
   *  @class
   *  @function PanelClose
   */
  class PanelClose extends HTMLElement {
  
    constructor() {
      super();
      let cc = document.querySelector('.click-capture');
  
      // Add functionality to buttons
      this.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            document.querySelectorAll('.side-panel').forEach((panel) => {
              panel.classList.remove('active');
              document.body.classList.remove('open-cc');
            });
          }
        }
      });
      cc.addEventListener('click', (e) => {
        document.body.classList.remove('open-cc');
        if (document.querySelector('.side-panel.active')) {
          document.querySelector('.side-panel.active').classList.remove('active');
        }
      });
    }
  
    close_panel(e) {
      e.preventDefault();
      let panel = e.target.closest('.side-panel');
      panel.classList.remove('active');
      document.body.classList.remove('open-cc');
    }
  }
  customElements.define('side-panel-close', PanelClose);
  
  /**
   *  @class
   *  @function CartDrawer
   */
  class CartDrawer {
  
    constructor() {
      this.container = document.getElementById('Cart-Drawer');
  
      if (!this.container) {
        return;
      }
      let button = document.getElementById('cart-drawer-toggle');
  
      if (!button) {
        return;
      }
      // Add functionality to buttons
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        this.container.classList.add('active');
        this.container.focus();
  
        dispatchCustomEvent('cart-drawer:open');
      });
  
      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);
  
      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });
  
      this.container.addEventListener('change', this.debouncedOnChange.bind(this));
  
      this.notesToggle();
      this.removeProductEvent();
      // Terms checkbox
      this.termsCheckbox();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
      this.removeProductEvent();
    }
    removeProductEvent() {
      let removes = this.container.querySelectorAll('.remove');
  
      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');
  
          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    termsCheckbox() {
      let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
        checkout_button = this.container.querySelector('.button.checkout');
  
      if (terms_checkbox && checkout_button) {
        terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
        checkout_button.addEventListener('click', function (e) {
          if (!terms_checkbox.checked) {
            terms_checkbox.reportValidity();
            terms_checkbox.focus();
            e.preventDefault();
          }
        });
      }
    }
    notesToggle() {
      let notes_toggle = document.getElementById('order-note-toggle');
  
      if (!notes_toggle) {
        return;
      }
  
      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes').value
        })
      });
    }
    updateQuantity(line, quantity) {
      this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
  
  
          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
  
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
  
          }));
  
          this.removeProductEvent();
          this.notesToggle();
          this.termsCheckbox();
  
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });
          if (this.container.querySelector(`#CartDrawerItem-${line}`).length) {
            this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
          }
        });
    }
    refresh() {
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
  
          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
  
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));
  
          this.removeProductEvent();
          this.notesToggle();
          this.termsCheckbox();
        });
    }
  }
  
  /**
   *  @class
   *  @function QuickView
   */
  if (!customElements.get('quick-view')) {
    class QuickView extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.cc = document.querySelector('.click-capture');
        this.drawer = document.getElementById('Product-Drawer');
        this.body = document.body;
  
        this.addEventListener('click', this.setupEventListener.bind(this));
        this.cc.addEventListener('click', this.setupCCEventListener.bind(this));
  
      }
      setupCCEventListener(e) {
        this.body.classList.remove('open-cc');
        this.drawer.classList.remove('active');
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
      }
      setupEventListener(e) {
        e.preventDefault();
        let productHandle = this.dataset.productHandle,
          href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;
  
        // remove double `/` in case shop might have /en or language in URL
        href = href.replace('//', '/');
        if (!href || !productHandle) {
          return;
        }
        if (this.classList.contains('loading')) {
          return;
        }
        this.classList.add('loading');
        fetch(href, {
          method: 'GET'
        })
          .then((response) => {
            this.classList.remove('loading');
            return response.text();
          })
          .then(text => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('#Product-Drawer-Content').innerHTML;
  
            this.renderQuickview(sectionInnerHTML, href, productHandle);
  
          });
      }
      renderQuickview(sectionInnerHTML, href, productHandle) {
        if (sectionInnerHTML) {
  
          this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;
  
          let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');
  
          if (js_files.length > 0) {
            var head = document.getElementsByTagName('head')[0];
            js_files.forEach((js_file, i) => {
              let script = document.createElement('script');
              script.src = js_file.src;
              head.appendChild(script);
            });
          }
  
          setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }
          }, 300);
  
  
  
          this.body.classList.add('open-cc');
          this.drawer.classList.add('active');
          this.drawer.querySelector('.side-panel-close').focus();
  
          dispatchCustomEvent('quick-view:open', {
            productUrl: href,
            productHandle: productHandle
          });
        }
      }
    }
    customElements.define('quick-view', QuickView);
  }
  
  /**
   *  @class
   *  @function ModalDialog
   */
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this)
      );
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
        });
      }
    }
  
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }
  
    show(opener) {
      this.openedBy = opener;
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
    }
  
    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      this.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      });
      this.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      this.querySelectorAll('video').forEach((video) => video.pause());
    }
  }
  customElements.define('modal-dialog', ModalDialog);
  
  class ModalOpener extends HTMLElement {
    constructor() {
      super();
  
      const button = this.querySelector('button');
  
      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define('modal-opener', ModalOpener);
  
  /**
   *  @class
   *  @function ProductRecommendations
   */
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
  
    }
    fetchProducts() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
  
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
  
          this.classList.add('product-recommendations--loaded');
        })
        .catch(e => {
          console.error(e);
        });
    }
    connectedCallback() {
      this.fetchProducts();
    }
  }
  
  customElements.define('product-recommendations', ProductRecommendations);
  
  /**
   *  @class
   *  @function Localization
   */
  class Localization {
    constructor() {
      let _this = this;
      // resize on initial load
      document.querySelectorAll(".thb-localization-forms").forEach((localization) => {
        localization.addEventListener("change", (e) => {
          localization.querySelector('form').submit();
        });
      });
    }
  }
  
  
  
  /**
   *  @class
   *  @function SelectWidth
   */
  class SelectWidth {
    constructor() {
      let _this = this;
      // resize on initial load
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
  
      // delegated listener on change
      document.body.addEventListener("change", (e) => {
        if (e.target.matches(".resize-select") && e.target.offsetParent !== null) {
          _this.resizeSelect(e.target);
        }
      });
      window.addEventListener('resize.resize-select', function () {
        document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
      });
    }
  
    resizeSelect(sel) {
      let tempOption = document.createElement('option');
      tempOption.textContent = sel.selectedOptions[0].textContent;
  
      let tempSelect = document.createElement('select');
      tempSelect.style.visibility = "hidden";
      tempSelect.style.position = "fixed";
      tempSelect.appendChild(tempOption);
  
      sel.after(tempSelect);
      if (tempSelect.clientWidth > 0) {
        sel.style.width = `${+tempSelect.clientWidth + 12}px`;
      }
      tempSelect.remove();
    }
  }
  
  /**
   *  @class
   *  @function CollapsibleRow
   */
  if (!customElements.get('collapsible-row')) {
    // https://css-tricks.com/how-to-animate-the-details-element/
    class CollapsibleRow extends HTMLElement {
      constructor() {
        super();
  
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.content = this.querySelector('.collapsible__content');
  
        // Store the animation object (so we can cancel it if needed)
        this.animation = null;
        // Store if the element is closing
        this.isClosing = false;
        // Store if the element is expanding
        this.isExpanding = false;
      }
      connectedCallback() {
        this.setListeners();
      }
      setListeners() {
        this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
      }
      prepareAnimations() {
        let _this = this,
          summary_height = this.querySelector('summary').offsetHeight,
          content_height = this.querySelector('.collapsible__content').offsetHeight,
          initial_height = summary_height,
          final_height = summary_height + content_height;
  
        this.tl = false;
        this.tl = gsap.timeline({
          reversed: !_this.details.open,
          paused: true,
          inherit: false,
          ease: 'none',
          onStart: function () {
            _this.details.open = true;
            _this.details.style.overflow = 'hidden';
          },
          onReverseComplete: function () {
            _this.details.open = false;
            _this.details.style.overflow = '';
          }
        });
  
        this.tl
          .fromTo(_this.details, {
            height: function () {
              let h = Math.max(Math.max(initial_height, 0), 24);
              return h;
            },
            clearProps: 'height'
          }, {
            duration: 0.4,
            height: final_height,
            clearProps: 'height'
          });
  
        if (this.details.open) {
          this.tl.progress(1);
        }
      }
      instantClose() {
        this.tl.timeScale(10).reverse();
      }
      animateClose() {
        this.tl.timeScale(3).reverse();
      }
      animateOpen() {
        this.tl.timeScale(1).play();
      }
      onClick(e) {
        // Stop default behaviour from the browser
        e.preventDefault();
        // Add an overflow on the <details> to avoid content overflowing
        this.details.style.overflow = 'hidden';
        // Check if the element is being closed or is already closed
        if (this.isClosing || !this.details.open) {
          this.open();
          // Check if the element is being openned or is already open
        } else if (this.isExpanding || this.details.open) {
          this.shrink();
        }
      }
      shrink() {
        // Set the element as "being closed"
        this.isClosing = true;
  
        // Store the current height of the element
        const startHeight = `${this.details.offsetHeight}px`;
        // Calculate the height of the summary
        const endHeight = `${this.summary.offsetHeight}px`;
  
        // If there is already an animation running
        if (this.animation) {
          // Cancel the current animation
          this.animation.cancel();
        }
  
        // Start a WAAPI animation
        this.animation = this.details.animate({
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight]
        }, {
          duration: 250,
          easing: 'ease'
        });
  
        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(false);
        // If the animation is cancelled, isClosing variable is set to false
        this.animation.oncancel = () => this.isClosing = false;
      }
  
      open() {
        // Apply a fixed height on the element
        this.details.style.height = `${this.details.offsetHeight}px`;
        // Force the [open] attribute on the details element
        this.details.open = true;
        // Wait for the next frame to call the expand function
        window.requestAnimationFrame(() => this.expand());
      }
  
      expand() {
        // Set the element as "being expanding"
        this.isExpanding = true;
        // Get the current fixed height of the element
        const startHeight = `${this.details.offsetHeight}px`;
        // Calculate the open height of the element (summary height + content height)
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
  
        // If there is already an animation running
        if (this.animation) {
          // Cancel the current animation
          this.animation.cancel();
        }
  
        // Start a WAAPI animation
        this.animation = this.details.animate({
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight]
        }, {
          duration: 400,
          easing: 'ease-out'
        });
        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(true);
        // If the animation is cancelled, isExpanding variable is set to false
        this.animation.oncancel = () => this.isExpanding = false;
      }
  
      onAnimationFinish(open) {
        // Set the open attribute based on the parameter
        this.details.open = open;
        // Clear the stored animation
        this.animation = null;
        // Reset isClosing & isExpanding
        this.isClosing = false;
        this.isExpanding = false;
        // Remove the overflow hidden and the fixed height
        this.details.style.height = this.details.style.overflow = '';
      }
    }
    customElements.define('collapsible-row', CollapsibleRow);
  }
  
  if (typeof SelectWidth !== 'undefined') {
    new SelectWidth();
  }
  document.addEventListener('DOMContentLoaded', () => {
  
    if (typeof Localization !== 'undefined') {
      new Localization();
    }
    if (typeof CartDrawer !== 'undefined') {
      new CartDrawer();
    }
  
  });
  
  
  
  
  //调整导航栏的search  点击放大镜header添加类名
  $(document).on("click", ".search-icon", function(e) {
    console.log("搜索2");
    $(".header-section").addClass("search-open");
  });
  
  
  
  
  
  // *********************测试 触脉代码*********************
  
  
  
  // *********************获取产品详情页所有的 td 更改内容*********************
  
  var productDetailsBox = document.querySelectorAll('.product-details-box');
  
  productDetailsBox.forEach(products => {
    var descriptionTable = products.querySelector('.product-short-description .description-table')
    if (descriptionTable) {
      // console.log('存在');
      var tdElement = descriptionTable.querySelector('tr:first-child td:nth-child(2)');
      var tdContent = tdElement.textContent;
      // console.log(tdContent + 2);
      if (tdContent) {
        tdElement.textContent = 'QVR Hair';
        // console.log('内容已更改');
      }
    } else {
      // console.log('不存在');
    }
  })
  
  
  // *********************自定义弹窗模块*********************
  
  
  //获取遮罩所有的关闭
  var cookiePolciyColse = document.querySelectorAll('.cookie-policy_colse')
  
  
  
  // cookie policy
  // 获取政策遮罩
  var closePageCookiePolicy = document.querySelector('.page-cookie_policy');
  // 获取政策选择模块
  var closeCookiePolicy = document.querySelector('.cookie_policy');
  // 获取所有关闭按钮
  var cookiePolicySwitch = document.querySelector('.cookie_policy .cookie_policy_switch')
  var cookiePolicyReject = document.querySelector('.cookie_policy .cookie_policy_reject')
  // 获取下拉列表按钮
  // titleDropDown1 titleDropDown2 弹窗不显示关闭暂停获取cookie5.15 
  // var titleDropDown1 = cookiePolicyReject.querySelector('.cookie_policy .policy_reject_title .title-drop-down1 ')
  // var titleDropDown2 = cookiePolicyReject.querySelector('.cookie_policy .policy_reject_title .title-drop-down2 ')
  
  
  // 检查是否是第一次访问网站
  var isFirstVisit = localStorage.getItem('isFirstVisit');
  
  // 如果是第一次访问网站  cookie弹窗不显示关闭第一次访问功能5.15
  // if (!isFirstVisit) {
  //   // console.log('第一次访问网站');
  
  //   // 执行你的逻辑
  //   cookiePolciyColseAlter();
  //   closePageCookiePolicy.style.display = "block";
  //   closeCookiePolicy.style.display = "block";
  //   changeCloseButton();
  //   changeSwitch();
  //   policyRejectDropDown();
  
  //   // 将标志位设置为 true
  //   localStorage.setItem('isFirstVisit', true);
  // }else{
  //   // console.log('第二次');
  //   cookiePolciyColseAlter();
  //   changeCloseButton();
  //   changeSwitch();
  //   policyRejectDropDown();
  // }
  
  
  
  
  // // 获取当前时间戳（毫秒）
  // var currentTime = Date.now();
  
  // // 获取上次访问时间戳（毫秒）
  // var lastVisitedTime = localStorage.getItem('lastVisitedTime');
  
  // // 如果上次访问时间不存在，或者距离上次访问超过 2 秒钟（2 * 1000 毫秒）
  // if (!lastVisitedTime || (currentTime - lastVisitedTime > 10 * 1000)) {
  //   console.log('开始时间' + currentTime + "最后时间" + lastVisitedTime);
  
  //   // 执行你的逻辑
  //   cookiePolciyColseAlter();
  //   closePageCookiePolicy.style.display = "block";
  //   closeCookiePolicy.style.display = "block";
  //   changeCloseButton();
  //   changeSwitch();
  //   policyRejectDropDown();
  
  //   // 更新上次访问时间为当前时间
  //   localStorage.setItem('lastVisitedTime', currentTime);
  // }
  
  
  
  //*********************cookie-policy 弹窗关闭*********************
  function cookiePolciyColseAlter() {
    cookiePolciyColse.forEach(div => {
      div.addEventListener('click', () => {
        // console.log('弹窗关闭');
        closePageCookiePolicy.style.display = "none";
        closeCookiePolicy.style.display = "none"
      })
    })
  }
  
  function changeCloseButton() {
    //  cookie_policy关闭按钮
    var changeButton = document.querySelectorAll('.change_button');
  
    changeButton.forEach(button => {
      button.addEventListener('click', () => {
        // console.log('关闭');
        closePageCookiePolicy.style.display = "none";
        closeCookiePolicy.style.display = "none"
      })
    })
  }
  
  //change_cookie_preferences 切换按钮
  function changeSwitch() {
    var changeCookiePreferences = document.querySelector('.cookie_policy .change_right .change_cookie_preferences')
  
    changeCookiePreferences.addEventListener('click', () => {
      // console.log('切换');
      cookiePolicySwitch.style.display = "none";
      cookiePolicyReject.style.display = "block"
    })
  
  }
  
  //下拉列表的按钮
  function policyRejectDropDown() {
    if (titleDropDown1) {
  
      titleDropDown1.addEventListener('click', () => {
        // console.log("第一个");
        var spanElement1 = document.querySelector('.span-txt1');
        var h3Icon = titleDropDown1.querySelector('.icon')
        spanElement1.classList.toggle('hidden-hight');
        h3Icon.classList.toggle('transform-rotaX');
  
      })
    }
    if (titleDropDown2) {
  
      titleDropDown2.addEventListener('click', () => {
        // console.log("第二个");
        var spanElement2 = document.querySelector('.span-txt2');
        var h3Icon = titleDropDown2.querySelector('.icon')
        spanElement2.classList.toggle('dis_none');
        h3Icon.classList.toggle('transform-rotaX');
      })
    }
  
    // 打开cookie policy 弹窗
    var cookiePolicyAlter = document.querySelector('.open-cookie-policy_alter')
  
    if (cookiePolicyAlter) {
      cookiePolicyAlter.addEventListener('click', () => {
        // console.log("打开cookie");
        closePageCookiePolicy.style.display = "block";
        closeCookiePolicy.style.display = "block";
      });
    }
  
  
  }
  
  //********************* 产品详情页 分期盒子 弹窗 头发颜色弹窗*********************
  
  // afterpay 点击
  const Afterpay = document.querySelector('.afterpay-msg')
  // klarna点击
  const Klarna = document.querySelector('.klarna-msg')
  // 头发颜色点击
  const HairColorAll = document.querySelectorAll('.hair-color_alter')
  //*********************分期盒子 弹窗*********************
  const Afterpaya = document.querySelector('.afterpay-msg')
  const Klarnaa = document.querySelector('.klarna-msg')
  const HairColora = document.querySelector('.hair-color_alter')
  const HairSizeGuide = document.querySelector('.hair-SizeGuide_alter')
  
  //打开产品页遮罩
  const openAlertCover = document.querySelector('.product-alter-cover')
  function openBlackCover() {
    openAlertCover.classList.add('dis_block_im')
  }
  
  //关闭产品页遮罩 
  const closeAlertCover = document.querySelector('.product-alter-cover')
  //遮罩封装
  function closeBlackCover() {
    closeAlertCover.classList.remove('dis_block_im')
  }
  //单击这种啊空白处
  function closeProductCover() {
    closeAlertCover.addEventListener('click', () => {
      closeBlackCover(),
        productAlterBox(),
        closeHairColorAlterBox()
    });
    closeAlertCover.addEventListener('click', () => {
      //   // 关闭 hair color 的弹窗
      closeHairColorAlterBox()
  
    });
  
  
  }
  
  //公共打开黑色遮罩功能 
  //注:只要在触发按钮添加open-product-cover就能打开公共黑色遮罩
  const openProductPageCover = document.querySelectorAll('.open-product-cover')
  // 打开遮罩 点击空白关闭的方法
  function AfterpayAndKlarna() {
    // 如果 Afterpay 是一个 NodeList 或类似的对象，将其转换为数组
    const afterpayArray = Array.from(openProductPageCover);
  
    afterpayArray.forEach((elOpenProductPageCover) => {
      const alertCover = document.querySelector('.product-alter-cover')
      elOpenProductPageCover.addEventListener('click', () => {
        //给弹窗添加展示class类 dis_block_im
        alertCover.classList.add('dis_block_im');
        closeProductCover();
        // closeHairColorAlterBox()
      });
  
    });
  }
  //**************************************/
  // afterpay 控制弹窗
  const afterpayBoxCover = document.querySelector('.afterpay-box')
  if (Afterpaya) {
    Afterpaya.addEventListener('click', () => {
      // console.log('点击66 没有打开遮罩5');
      openBlackCover()
      afterpayBoxCover.classList.add('dis_block_im')
      closeProductCover();
    })
  }
  //**************************************/
  // Klarna 控制弹窗 没有打开klarna-box盒子不要使用Klarna功能，否则会导致下面代码功能失效
  const klarnaBoxCover = document.querySelector('.klarna-box')
  if (Klarnaa) {
    Klarnaa.addEventListener('click', () => {
      // console.log('点击3');
      klarnaBoxCover.classList.add('dis_block_im')
    })
  }
  //**************************************/
  //头发颜色监听
  // 获取头发颜色弹窗遮罩
  const hairColorBoxCover = document.querySelector('.hair-color_box')
  if (HairColorAll) {
    HairColorAll.forEach(el => {
      el.addEventListener('click', () => {
        hairColorBoxCover.classList.add('dis_block_im')
        closeProductCover();
        // console.log('打印了');
      })
    })
  }
  
  
  //**************************************/
  
  
  //**************************************/
  // afterpay关闭按钮
  const afterpayClose = document.querySelector('.afterpay-box .con-close')
  if (afterpayClose) {
  
    afterpayClose.addEventListener('click', () => {
      closeBlackCover()
      productAlterBox()
    })
  }
  //klarna关闭按钮
  const klarnaPayClose = document.querySelector('.klarna-box .con-close')
  if (klarnaPayClose) {
  
    klarnaPayClose.addEventListener('click', () => {
      closeBlackCover()
      productAlterBox()
    })
  }
  
  // 头发关闭按钮
  const hairColorClose = document.querySelector('.hair-color_box .con-close')
  if (hairColorClose) {
  
    hairColorClose.addEventListener('click', () => {
      // console.log('关闭按钮');
      closeBlackCover(),
        closeHairColorAlterBox()
    })
  }
  
  
  
  
  //afterpay和klarna单独封装弹窗
  function productAlterBox() {
    if (afterpayBoxCover && afterpayBoxCover.classList.contains('dis_block_im')) {
      // console.log(11);
      afterpayBoxCover.classList.remove('dis_block_im');
    }
  
    if (klarnaBoxCover && klarnaBoxCover.classList.contains('dis_block_im')) {
      // console.log(22);
      klarnaBoxCover.classList.remove('dis_block_im');
    }
  
  
  }
  // hairColor 关闭
  function closeHairColorAlterBox() {
    if (hairColorBoxCover && hairColorBoxCover.classList.contains('dis_block_im')) {
      hairColorBoxCover.classList.remove('dis_block_im');
    }
  }
  
  // AfterpayAndKlarna();
  document.addEventListener('DOMContentLoaded', function () {
    AfterpayAndKlarna();
  });
  
  $(document).ready(function () {
    //获取弹窗元素
    var registerImg = $('.register-img');
    var registerBox = $('.register-box');
    var registerClose = $('.register-close');
  
    var formSuccesss = document.querySelector('.form_success')
  
    // 点击图片显示注册框
    if (registerImg) {
      registerImg.on("click", function () {
        registerBox.attr('aria-hidden', 'false');
      });
    }
  
    // 点击关闭按钮隐藏注册框
    if (registerClose) {
      registerClose.on("click", function () {
        registerBox.attr('aria-hidden', 'true');
      });
    }
  
  
  
    function createCenterBoxOnceEveryTwoHours(successText) {
      const lastClosedKey = 'lastClosedBoxTime';
      const currentTime = new Date().getTime();
      const twoHoursInMilliseconds = 1 * 60 * 60 * 1000;
      // const twoHoursInMilliseconds = 5000;
  
      const lastClosedTime = localStorage.getItem(lastClosedKey);
  
      // 检查上次关闭盒子的时间是否超过两个小时
      if (!lastClosedTime || currentTime - lastClosedTime > twoHoursInMilliseconds) {
        if (successText === 'Thanks for subscribing') {
          // console.log(successText + ' 文本响应内容33333');
  
          // 创建一个新的 div 元素作为定位盒子
          var centerBox = document.createElement('div');
          centerBox.classList.add('register-box-ones-alter');
          // centerBox.textContent = 'This is the center box';
  
          // 设置定位盒子的样式和属性
          centerBox.style.position = 'fixed';
          centerBox.style.cursor = 'pointer';
          centerBox.style.zIndex = '500'; // 注意：z-index 应该用驼峰命名法
          centerBox.style.marginTop = '-100px'; // 使盒子垂直居中
          centerBox.style.marginLeft = '-170px'; // 使盒子水平居中（调整以确保居中）
          centerBox.style.backgroundColor = '#fff';
          centerBox.style.backgroundImage = 'url("https://cdn.shopify.com/s/files/1/0053/7372/2670/files/a016b412f93b877a827866a90379da25.png?v=1717133641")'; // 替换为你的图片路径
          centerBox.style.backgroundSize = 'cover';
          centerBox.style.textAlign = 'center';
          centerBox.style.lineHeight = '200px';
          centerBox.style.borderRadius = '0px';
          centerBox.setAttribute('aria-hidden', 'false');
          centerBox.classList.add('register-close');
          centerBox.style.boxShadow = '#0006 0 12px 27px 2px';
  
          // 添加点击事件监听器，点击时隐藏盒子并记录关闭时间
          centerBox.addEventListener('click', function () {
            centerBox.style.display = 'none';
            localStorage.setItem(lastClosedKey, currentTime);
          });
  
          // 将定位盒子添加到页面中
          document.body.appendChild(centerBox);
        }
      } else {
        // console.log('盒子在两个小时内只能创建一次。');
      }
    }
  
    // 假设 formSuccesss 是一个包含成功信息的元素
    if (formSuccesss) {
      var registerBoxFalse = document.querySelector('.register-box');
      if (registerBoxFalse) {
        registerBoxFalse.style.top = '-30rem';
      }
  
      // console.log('获取到弹窗 添加盒子');
      var successText = formSuccesss.textContent.trim();
      createCenterBoxOnceEveryTwoHours(successText);
    }
  
  
  
  
    //copy 折扣码
    var discountDorpDown = $('.discount-code-dorp_down')
    // 获取pc
    var discountDorpDownIPC = $('.discount-code-dorp_down_pc .discount-code-dorp_down-i')
    var discountBoxPC = $('.discount-code-box_pc')
    // 获取m端
    var discountDorpDownIM = $('.discount-code-dorp_down_mobile .discount-code-dorp_down-i')
    var discountBoxM = $('.discount-code-box_mobile')
  
    var copyDiscountCode = $('.text-discount-copy');
  
    if (discountDorpDown.length) {
      discountDorpDown.each(function () {
        $(this).on('click', function () {
          // console.log('下拉2');
          // pc端逻辑
          var ariaHidden = discountBoxPC.attr('aria-hidden');
          var ariaHiddenI = discountDorpDownIPC.attr('aria-hidden')
  
          if (ariaHidden === 'true' && ariaHiddenI === 'true') {
            discountBoxPC.attr('aria-hidden', 'false');
            discountDorpDownIPC.attr('aria-hidden', 'false');
          } else {
            discountBoxPC.attr('aria-hidden', 'true');
            discountDorpDownIPC.attr('aria-hidden', 'true');
          }
          //手机端逻辑
          var ariaHidden = discountBoxM.attr('aria-hidden');
          var ariaHiddenI = discountDorpDownIM.attr('aria-hidden')
  
          if (ariaHidden === 'false' && ariaHiddenI === 'false') {
            discountBoxM.attr('aria-hidden', 'true');
            discountDorpDownIM.attr('aria-hidden', 'true');
          } else {
            discountBoxM.attr('aria-hidden', 'false');
            discountDorpDownIM.attr('aria-hidden', 'false');
          }
  
        });
      });
    }
  
    // 在按钮点击事件处理程序中直接获取要复制的内容
  
    if (copyDiscountCode.length) {
      copyDiscountCode.each(function () {
        $(this).find('button').on('click', function () {
          // 获取要复制的内容
          var copyCode = $(this).siblings('.flex').find('.text-discount-p').text().trim();
          // console.log('要复制的内容:', copyCode); // 输出要复制的内容
  
          // 将内容复制到剪贴板
          var tempInput = $('<textarea>');
          $('body').append(tempInput);
          tempInput.val(copyCode).select();
  
          var successful = document.execCommand('copy');
          // console.log('复制是否成功:', successful); // 输出复制是否成功
  
          tempInput.remove();
          // console.log('临时文本区域已移除'); // 确认移除操作
  
          // 更改按钮文本为 "Copied"
          if (successful) {
            $(this).text('Copied');
  
            // 可选：一段时间后恢复按钮文本
            // var button = $(this);
            // setTimeout(function () {
            //     button.text('copy');
            // }, 2000); // 2秒后恢复
          }
        });
      });
    }
  
    // ******************************************************************
  
  
  });
  
  
  
  $(document).ready(function () {
    // 添加占位符
    $('.tabs-loading-more-button1').each(function () {
      const $tabLoading = $(this);
      const $collectionContainer = $tabLoading.find('.link1-collection1');
      const $items = $collectionContainer.children('.link1-collection1-product-con');
      const itemCount = $items.length;
      const itemsPerRow = 4;
      const remainder = itemCount % itemsPerRow;
  
      if (remainder !== 0) {
        const placeholdersToAdd = itemsPerRow - remainder;
        for (let i = 0; i < placeholdersToAdd; i++) {
          const $placeholder = $('<div>').addClass('link1-collection1-product-con placeholder');
          $collectionContainer.append($placeholder);
        }
      }
    });
   // 添加占位符
    $('.tabs-loading-more-button3').each(function () {
      const $tabLoading = $(this);
      const $collectionContainer = $tabLoading.find('.link1-collection1');
      const $items = $collectionContainer.children('.link3-collection3-product-con');
      const itemCount = $items.length;
      const itemsPerRow = 4;
      const remainder = itemCount % itemsPerRow;
  
      if (remainder !== 0) {
        const placeholdersToAdd = itemsPerRow - remainder;
        for (let i = 0; i < placeholdersToAdd; i++) {
          const $placeholder = $('<div>').addClass('link3-collection3-product-con placeholder');
          $collectionContainer.append($placeholder);
        }
      }
    });
    // clearance sale 模块  添加占位符 
    $('.clearance-sale-loading-more-button1').each(function () {
      const $tabLoading = $(this);
      const $collectionContainer = $tabLoading.find('.link1-collection1');
      const $items = $collectionContainer.children('.link1-collection1-product-con');
      const itemCount = $items.length;
      const itemsPerRow = 4;
      const remainder = itemCount % itemsPerRow;
  
      if (remainder !== 0) {
        const placeholdersToAdd = itemsPerRow - remainder;
        for (let i = 0; i < placeholdersToAdd; i++) {
          const $placeholder = $('<div>').addClass('link1-collection1-product-con placeholder');
          $collectionContainer.append($placeholder);
        }
      }
    });
  
  
  });
  
  
  
  
  
  //产品详情 色卡 js
  document.addEventListener("DOMContentLoaded", function() {
    // 获取所有 .variant-color-down 和 .variant-color-up 的标签
    var variantColorDowns = document.querySelectorAll('.variant-color-down');
    
    variantColorDowns.forEach(function(variantDown) {
      // 获取上一个兄弟节点（.variant-color-up）
      var variantUp = variantDown.previousElementSibling;
      
      if (variantUp && variantUp.classList.contains('variant-color-up')) {
        // 获取 .variant-color-down 的 style 信息
        var downStyle = variantDown.getAttribute('style');
        
        // 将 .variant-color-down 的 style 应用到 .variant-color-up
        variantUp.setAttribute('style', downStyle);
      }
    });
  });
  
  
  // ------------------------------------
  // 封装的 applyVariantColorStyles 函数
  function applyVariantColorStyles(parentSelector) {
    console.log('applyVariantColorStyles 函数已调用');
    var parentElement = document.querySelector(parentSelector);
    
    if (!parentElement) {
      console.log('未找到元素:', parentSelector);
      return;
    }
  
    // 获取所有 .variant-color-up 元素，清除它们之前的 style
    var variantColorUps = parentElement.querySelectorAll('.variant-color-up');
    variantColorUps.forEach(function(variantUp) {
      variantUp.removeAttribute('style'); // 清除之前的样式
    });
  
    // 获取 .variant-color-down 的样式，并应用到 .variant-color-up
    var variantColorDowns = parentElement.querySelectorAll('.variant-color-down');
    variantColorDowns.forEach(function(variantDown) {
      var variantUp = variantDown.previousElementSibling;
      if (variantUp && variantUp.classList.contains('variant-color-up')) {
        var downStyle = variantDown.getAttribute('style');
        variantUp.setAttribute('style', downStyle); // 应用样式
      }
    });
  }
  
  // 监听 div.side-panel.product-drawer 的 class 变化
  function observeProductDrawer() {
    var productDrawer = document.querySelector('div.side-panel.product-drawer');
    
    if (!productDrawer) {
      console.log('未找到 div.side-panel.product-drawer 元素');
      return;
    }
  
    // 创建 MutationObserver 实例
    var observer = new MutationObserver(function(mutationsList) {
      mutationsList.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          // 当 class 发生变化时，检查是否包含 'active'
          if (productDrawer.classList.contains('active')) {
            console.log('检测到 active class，观察 调用 applyVariantColorStyles');
            setTimeout(function() {
              applyVariantColorStyles('body'); // 或其他父容器选择器
            }, 1000); // 延迟 1 秒
          }
        }
      });
    });
  
    // 配置观察选项，观察 attributes
    observer.observe(productDrawer, {
      attributes: true // 仅观察属性的变化
    });
  }
  
  // DOM 加载完毕后执行
  document.addEventListener('DOMContentLoaded', function() {
    // 监听 div.side-panel.product-drawer 的 class 变化
    observeProductDrawer();
  });
  
  // 产品详情 色卡js end
  
  
  
  
  
  document.addEventListener('DOMContentLoaded', function() {
    console.log('christmas-buy-3-get-1-free 产品详情合集');
    
    // christmas-buy-3-get-1-free 产品详情合集
    const $productDetail = $('.thb-product-detail');
    if ($productDetail.length > 0) {
      console.log("不为空");
      
      var productCollection = $productDetail.data('v4-collection');
      console.log(productCollection, "产品合集");
      if (productCollection =='christmas-buy-3-get-1-free') {
        console.log("开始执行");
        var $flickitySlide = $('.thb-product-detail .product-gallery-sticky .flickity-viewport .flickity-slider')
  
         // 找到第一个子元素并添加样式
         $flickitySlide.find(':first-child').css({
          'left': '0px',
          'transform': 'translateX(-100%)'
        });
      }
  
  
    }
  });
  
  
  
  
  document.addEventListener('DOMContentLoaded', function() {
    // clearance sale 模块
    const clearanceSaleBox = document.querySelector('.clearance-sale .collection-tabs-view-more-collection1');
    const collectionTabsList = document.querySelector('.clearance-sale .clearance-sale-title-pc');
    const headersBox = document.querySelector('.header .expanded')
    
    if (!clearanceSaleBox || !collectionTabsList) {
        console.error('clearance-sale or clearance-sale-title-pc not found');
        return;
    }
  
    // 防抖函数
    function debounce(fn, delay) {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => fn.apply(this, args), delay);
        };
    }
  
    // 节流函数，确保在一定时间内只执行一次
    function throttle(fn, delay) {
        let lastCall = 0;
        return function(...args) {
            const now = new Date().getTime();
            if (now - lastCall < delay) {
                return;
            }
            lastCall = now;
            return fn(...args);
        };
    }
  
    // 状态标志，标记是否已添加或移除类名
    let classAdded = false;
  
    // 分别创建添加和移除类名的防抖函数
    const addDebounced = debounce(() => {
        if (!classAdded) {  // 只有类名未添加时才执行
            collectionTabsList.classList.add('clearance-sale_pos');
            headersBox.classList.add('dis_none');
            classAdded = true;  // 更新状态，表示类名已添加
        }
    }, 600); // 添加类名有 600ms 的延迟
  
    const removeDebounced = debounce(() => {
        if (classAdded) {  // 只有类名已添加时才执行移除
            collectionTabsList.classList.remove('clearance-sale_pos');
            headersBox.classList.remove('dis_none');
            classAdded = false; // 更新状态，表示类名已移除
        }
    }, 500); // 移除类名有 100ms 的延迟
  
    // 滚动处理逻辑
    function handleScroll() {
        const boxRect = clearanceSaleBox.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        
        // 缓冲范围定义为 5% 的视口高度
        const buffer = viewportHeight * 0.05;
  
        // 滑动到clearance-sale占视口的80%时，添加类名，缓冲区域为 75% - 85%
        if (boxRect.top < viewportHeight * 0.15 && boxRect.bottom > viewportHeight * 0.85) {
            if (!classAdded) {
                addDebounced(); // 使用600ms延迟的防抖函数添加类名
            }
        } else {
            if (classAdded) {
                removeDebounced(); // 使用100ms延迟的防抖函数移除类名
            }
        }
  
        // 从下面往上滑动到占视口50%时，缓冲区域为 45% - 55%
        if (boxRect.top < viewportHeight * 0.55 && boxRect.bottom > viewportHeight * 0.45) {
            if (!classAdded) {
                addDebounced(); // 再次检测并添加类名
            }
        }
    }
  
    // 将滚动处理函数节流并绑定到scroll事件，防止滚动事件触发过于频繁
    const throttledScrollHandler = throttle(handleScroll, 200); // 200ms 节流
  
    // 监听滚动事件
    window.addEventListener('scroll', throttledScrollHandler);
    
  // clearance sale end 模块
  
  
  
  
  
  
  
  });
  
  
  
  // -------------------------------------
  $(document).ready(function() {
  
  
  // product-card-quickview
  
  
  });
  
  // -----------------------------------------------
  // vip价格计算 详情页
  // 版本1
  
  var priceMoney = parseFloat($('.price .amount-show').text().replace(/[^0-9.-]+/g, '').trim())
  var priceCoustomText = $('.price-coustom').text().trim()
  
  
  if (priceCoustomText) {
    vipDiscount()
  }
  function vipDiscount() {
  
    priceCoustom = parseFloat(priceCoustomText.replace(/[^0-9.-]+/g, ''))
   
    var productVipPrice = priceMoney * priceCoustom;
    // console.log("现价：",priceMoney , "折扣比例：", priceCoustom,"vip价格:",productVipPrice);
    $('.vip-price').text("$" + productVipPrice.toFixed(2));
  }   
  
  // console.log("查看",priceCoustom);
  
  $('.featured-collection__collection .products li.product-li').each(function () {
    // console.log('产品数22');
    var $this = $(this);
    // 假设价格数值在类名为.amount-show的元素中
    var priceText = $this.find('product-card .price .amount.331').text().trim();
    // 将价格文本转换为浮点数
    var price = parseFloat(priceText.replace(/[^0-9.-]+/g, ''));
    // 打印价格数值
    // console.log('产品价格:', price);
    var productVip = price * priceCoustom;
    $this.find('.section-vip-price').text("$" + productVip.toFixed(2));
  })
  
  // -------------------------------------
  
  
  
  
  
  
  